import request from '@/utils/request'

// 获取验证码加密串
export function generate(token) {
  return request.get('/api/service/vcode/generate', token);
}

// 获取七牛上传token
export function getQiniuToken(data) {
  return request.get('/api/admin/common/getToken', data);
}


// WEBPACK FOOTER //
// ./src/api/service.js